export default "__VITE_ASSET__qH_w39Uq__"